import {
  CmsContentTermsSchema,
  type CmsContentTermsForm,
} from "@/modules/cms/domain/contracts";
import { FormTipTapEditor } from "@/shared/ui/FormTipTapEditor";
import { Button, FormCheckbox, FormRoot, RHF, zodResolver } from "@devhop/ui";
import type { Resolver, UseFormReturn } from "react-hook-form";

type TermsFormProps = {
  content: CmsContentTermsForm | null;
  onSubmit: (content: CmsContentTermsForm) => void;
  onCancel: () => void;
  submitting?: boolean;
};

const defaultContent: CmsContentTermsForm = {
  content: {},
  isActive: true,
};

export function TermsForm({
  content,
  onSubmit,
  onCancel,
  submitting,
}: TermsFormProps) {
  const methods = RHF.useForm<CmsContentTermsForm>({
    resolver: zodResolver(
      CmsContentTermsSchema,
    ) as Resolver<CmsContentTermsForm>,
    defaultValues: content ?? defaultContent,
  });

  return (
    <FormRoot<CmsContentTermsForm>
      methods={methods as UseFormReturn<CmsContentTermsForm>}
      onSubmit={onSubmit}
    >
      <div className="space-y-6">
        <div className="space-y-2">
          <span className="font-medium text-sm">ເນື້ອຫາ (HTML)</span>
          <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
            <FormTipTapEditor
              name="content.lo"
              label="ລາວ"
              placeholder="ເພີ່ມເນື້ອຫາຂໍ້ຕົກລົງ (ລາວ)..."
            />
            <FormTipTapEditor
              name="content.th"
              label="ໄທ"
              placeholder="ເພີ່ມເນື້ອຫາຂໍ້ຕົກລົງ (ໄທ)..."
            />
            <FormTipTapEditor
              name="content.en"
              label="EN"
              placeholder="Add terms of service content (EN)..."
            />
          </div>
        </div>
        <FormCheckbox name="isActive" label="ເປີດໃຊ້ງານ" />
        <div className="flex gap-2 pt-2">
          <Button type="submit" disabled={submitting}>
            {submitting ? "ກຳລັງບັນທຶກ..." : "ບັນທຶກ"}
          </Button>
          <Button type="button" variant="outline" onClick={onCancel}>
            ຍົກເລີກ
          </Button>
        </div>
      </div>
    </FormRoot>
  );
}
